import React, { useState } from 'react';
import { Dialog, ElevatedButton, TextButton } from '@producer/ui-kit';

import { ArrowDown } from '../icons/ArrowDown';

import styles from './EstimatedTimeSelector.module.scss';
interface TimeSelectorProps {
  time?: number;
  onTimeChange: (time: number) => void;
  onCancel: () => void;
}

const DEFAULT_MINUTE_INCREMENT = 15;

export const EstimatedTimeSelector: React.FC<TimeSelectorProps> = ({
  time,
  onTimeChange,
  onCancel,
}) => {
  const [internalTime, setInternalTime] = useState<number>(time || 0);

  const handleClear = (e: any) => {
    e.stopPropagation();
    setInternalTime(0);
  };

  const handleSubmitTime = (e: any) => {
    e.stopPropagation();
    onTimeChange(internalTime);
    onCancel();
  };

  const handleTimeChange = (type: 'hours' | 'minutes') => (e: any) => {
    e.stopPropagation();
    const value = e.target.value;
    if (isNaN(+value)) {
      return;
    }
    if (type === 'hours') {
      setInternalTime(+value * 60 + (internalTime % 60));
    } else {
      setInternalTime(Math.floor(internalTime / 60) * 60 + +value);
    }
  };

  const incrementTime = (type: 'hours' | 'minutes') => (e: any) => {
    e.stopPropagation();
    const newTime = type === 'hours' ? internalTime + 60 : internalTime + DEFAULT_MINUTE_INCREMENT;
    setInternalTime(newTime);
  };

  const decrementTime = (type: 'hours' | 'minutes') => (e: any) => {
    e.stopPropagation();
    const newTime = type === 'hours' ? internalTime - 60 : internalTime - DEFAULT_MINUTE_INCREMENT;
    setInternalTime(newTime < 0 ? 0 : newTime);
  };

  return (
    <Dialog
      title="Estimated time"
      onClose={onCancel}
      actions={[
        <TextButton key="time-selector-clear-button" text="Clear" onClick={handleClear} />,
        <ElevatedButton
          key="time-selector-submit-button"
          text="Submit"
          onClick={handleSubmitTime}
        />,
      ]}
    >
      <div className={styles['dialog-content']}>
        <div className={styles['time-selector-container']}>
          <div className={styles['time-input-container']}>
            <div className={styles['up-arrow-container']} onClick={incrementTime('hours')}>
              <ArrowDown />
            </div>

            <input
              className={styles['time-input']}
              type="text"
              maxLength={2}
              value={Math.floor(internalTime / 60)}
              onChange={handleTimeChange('hours')}
            />

            <div className={styles['down-arrow-container']} onClick={decrementTime('hours')}>
              <ArrowDown />
            </div>
          </div>

          <span className={styles['time-letters']}>h</span>

          <div className={styles['time-input-container']}>
            <div className={styles['up-arrow-container']} onClick={incrementTime('minutes')}>
              <ArrowDown />
            </div>

            <input
              className={styles['time-input']}
              type="text"
              maxLength={2}
              value={internalTime % 60}
              onChange={handleTimeChange('minutes')}
            />

            <div className={styles['down-arrow-container']} onClick={decrementTime('minutes')}>
              <ArrowDown />
            </div>
          </div>

          <span className={styles['time-letters']}>m</span>
        </div>
      </div>
    </Dialog>
  );
};
